/**
 * 環境變數配置
 * 統一管理所有環境相關的配置
 */

const getEnv = (key: string, fallback = ''): string => {
  return (import.meta.env[key] as string) || fallback;
};

const getBool = (key: string, fallback = false): boolean => {
  const raw = getEnv(key, fallback ? 'true' : 'false').toLowerCase();
  return raw === 'true';
};

const getInt = (key: string, fallback: number): number => {
  const raw = getEnv(key, String(fallback));
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) ? n : fallback;
};

const getMode = (): string => {
  return import.meta.env.MODE || 'development';
};

const mode = getMode();

// 環境變數配置
export const env = {
  // API 配置
  apiBaseUrl: getEnv('VITE_API_BASE_URL', 'https://uuspa-server-610955567337.asia-east1.run.app'),
  apiTimeout: getInt('VITE_API_TIMEOUT', 30000),

  // 應用配置
  appName: getEnv('VITE_APP_NAME', 'UUSPA Admin'),
  appVersion: getEnv('VITE_APP_VERSION', '1.0.0'),

  // 功能開關
  enableDebug: getBool('VITE_ENABLE_DEBUG', false),
  enableAnalytics: getBool('VITE_ENABLE_ANALYTICS', false),

  // 第三方服務
  sentryDsn: getEnv('VITE_SENTRY_DSN', ''),
  googleAnalyticsId: getEnv('VITE_GOOGLE_ANALYTICS_ID', ''),

  // 開發環境配置
  isDevelopment: mode === 'development',
  isProduction: mode === 'production',
  isTest: mode === 'test',
};

// 環境變數類型定義
export interface EnvConfig {
  apiBaseUrl: string;
  apiTimeout: number;
  appName: string;
  appVersion: string;
  enableDebug: boolean;
  enableAnalytics: boolean;
  sentryDsn: string;
  googleAnalyticsId: string;
  isDevelopment: boolean;
  isProduction: boolean;
  isTest: boolean;
}

// 驗證環境變數
export function validateEnv(): void {
  const requiredVars = ['VITE_API_BASE_URL'];

  const missingVars = requiredVars.filter((key) => {
    const v = import.meta.env[key];
    return !v;
  });

  if (missingVars.length > 0) {
    console.warn('Missing required environment variables:', missingVars);
  }
}
